var _style, _path, _path2, _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRobothink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 207.1,
    height: 99.1,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#fff}.st1{fill:#13305c}.st2{fill:url(#SVGID_1_)}.st3{fill:url(#SVGID_2_)}.st4{fill:url(#SVGID_3_)}.st5{fill:url(#SVGID_4_)}.st6{fill:url(#SVGID_5_)}.st7{fill:url(#SVGID_6_)}.st8{fill:url(#SVGID_7_)}.st9{fill:url(#SVGID_8_)}.st10{fill:url(#SVGID_9_)}.st11{fill:url(#SVGID_10_)}.st12{fill:url(#SVGID_11_)}.st13{fill:url(#SVGID_12_)}.st14{fill:url(#SVGID_13_)}.st15{fill:url(#SVGID_14_)}.st16{fill:url(#SVGID_15_)}.st17{fill:url(#SVGID_16_)}.st18{fill:url(#SVGID_17_)}.st19{fill:url(#SVGID_18_)}.st20{fill:url(#SVGID_19_)}.st21{fill:url(#SVGID_20_)}.st22{fill:url(#SVGID_21_)}.st23{fill:url(#SVGID_22_)}.st24{opacity:.7;fill:#fff}.st25{fill:url(#SVGID_23_)}.st26{fill:url(#SVGID_24_)}.st27{fill:url(#SVGID_25_)}.st28{fill:url(#SVGID_26_)}.st29{fill:url(#SVGID_27_)}.st30{fill:url(#SVGID_28_)}.st31{fill:url(#SVGID_29_)}.st32{fill:url(#SVGID_30_)}.st33{fill:url(#SVGID_31_)}.st34{fill:url(#SVGID_32_)}.st35{fill:url(#SVGID_33_)}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M78.6 92.2v-.5c0-.4-.1-.7-.3-1.1-.2-.5-.4-.9-.7-1.2-.3-.4-.7-.7-1.2-.9-1-.4-2.4-.4-3.4 0-.3.1-.5.3-.8.5v-1.6c0-.9-.8-1.7-1.7-1.7h-1.6c-.9 0-1.7.8-1.7 1.7v.8c-.2 0-.4.1-.5.2-.5.2-1 .5-1.4.9 0 0 0 .1-.1.1 0 0 0-.1-.1-.1-.4-.4-.9-.7-1.4-.9-1-.4-2.3-.4-3.4 0-.1 0-.2.1-.3.1-.1-.8-.7-1.5-1.5-1.6-.1-.1-.2-.2-.3-.2-.4-.3-.8-.5-1.3-.7-1.1-.4-2.7-.4-3.9.1-.6.3-1.2.7-1.7 1.2s-.8 1.1-1.1 1.8c-.2.7-.4 1.4-.4 2.1 0 .5.1 1 .2 1.5-.2-.1-.3-.3-.5-.3l-1.1-.4c-.4-.2-.9-.2-1.3 0v-4.8c0-.9-.8-1.7-1.7-1.7h-1.6c-.9 0-1.7.8-1.7 1.7v.8c-.2 0-.4.1-.5.2-.4.2-.7.4-1 .6v-1.7c0-.9-.8-1.7-1.7-1.7h-1.7c-.4 0-.8.2-1.1.5-.1 0-.1-.1-.2-.2-.6-.2-1.2-.3-1.9 0-.3.1-.5.3-.7.5-.2.2-.4.4-.5.7-.1.3-.2.6-.2.9 0 .2 0 .3.1.5-.3-.2-.7-.4-1.1-.4H30c-.3 0-.6.1-.8.2-.2-.1-.5-.2-.8-.2h-1.2c-.2-.5-.5-.9-.8-1.2-.3-.3-.8-.6-1.2-.8-.5-.2-1-.3-1.5-.3h-3.4c-.5-.1-.9.2-1.2.5-.3.3-.5.8-.5 1.2v.9c0 .6.3 1.1.7 1.4v3c-.4.3-.7.8-.7 1.4v.8c0 .9.8 1.7 1.7 1.7h3.4c.5 0 1.1-.1 1.5-.3.5-.2.9-.5 1.2-.8 0 0 0-.1.1-.1.1.1.1.3.2.3.3.4.7.6 1.2.8.4.1.8.2 1.3.2.4 0 .8-.1 1.2-.2.1 0 .3.1.5.1h1.5c.3 0 .6-.1.8-.2.2.1.5.2.8.2h2.4c.2 0 .4-.1.5-.1.2.1.3.1.5.1h2.4c.5 0 .9-.2 1.2-.6.2.1.5.3.7.4.5.2 1 .3 1.6.3.4 0 .7 0 1-.1h1.1c.1.6.5 1.1 1.1 1.3l.7.3c.2.1.4.1.6.1.6 0 1.2-.4 1.5-1l1.3-2.7c.1-.2.1-.4.2-.6.2.4.4.7.7 1 .5.5 1.1.9 1.7 1.2.6.3 1.4.4 2.1.4.8 0 1.5-.2 2.2-.5.5-.2 1-.6 1.4-1l.1.1c.4.4.9.7 1.4 1 .5.2 1.1.3 1.7.3.6 0 1.2-.1 1.7-.3.5-.2 1-.6 1.4-1 0 0 0-.1.1-.1 0 0 0 .1.1.1.4.4.9.7 1.4.9.5.2 1 .3 1.6.3.4 0 .7 0 1-.1h2c.5 0 .9-.2 1.2-.5.2.1.5.3.7.4.5.2 1 .3 1.6.3.5 0 1.1-.1 1.6-.3.5-.2 1-.4 1.4-.7.7-.5 1-1.5.5-2.3.2-.3.4-.7.4-1l-.2.1zM34 87.7c0-.1.1-.2.2-.3.1-.1.2-.2.3-.2.3-.1.6-.1.9 0 .1 0 .1.1.2.1v.6c0-.1-.1-.1-.1-.2-.1-.1-.1-.1-.2-.1s-.2-.1-.2-.1c-.1 0-.2 0-.3.1-.1 0-.1.1-.2.1-.1.1-.1.1-.1.2s-.1.2-.1.2v.1H34v-.1-.4zM100 87.4c0-.9-.8-1.7-1.7-1.7h-1.6c-.9 0-1.7.8-1.7 1.7v.8c-.2 0-.4.1-.5.2-.5.2-1 .5-1.4.9-.1.1-.1.2-.2.3-.1-.2-.3-.4-.4-.5-.3-.3-.7-.6-1.2-.8-.7-.2-1.5-.3-2.2-.1-.1 0-.2 0-.2.1-.2-.1-.3-.1-.5-.1h-1.6c-.6 0-1 .3-1.3.7-.3-.3-.7-.5-1.2-.6-.6-.2-1.3-.2-2.1-.1-.2 0-.5.1-.7.2-.2.1-.5.2-.7.3l-.6.3c-.7.5-1 1.4-.6 2.2l.2.5c-.2.3-.4.6-.5.9-.1.4-.2.8-.2 1.2 0 .5.1.9.3 1.3.2.4.4.7.8 1 .3.3.7.5 1.1.6.4.2.8.2 1.3.2.4 0 .8-.1 1.1-.2h1.8c.2 0 .4 0 .6-.1.2.1.4.1.6.1H89c.2 0 .3 0 .5-.1.2 0 .3.1.5.1h2.4c.5 0 1-.2 1.3-.6.2.2.5.3.8.4.5.2 1 .3 1.6.3.4 0 .7 0 1-.1H99c.9 0 1.7-.8 1.7-1.7v-.8c0-.6-.3-1.1-.8-1.4v-5.4zM149.7 91.8c0-.5-.1-1-.2-1.4-.2-.5-.4-.9-.8-1.2-.3-.3-.7-.6-1.2-.8-.4-.1-.8-.2-1.2-.2v-.8c0-.9-.8-1.7-1.7-1.7H143c-.8 0-1.4.5-1.6 1.3 0 0 0-.1-.1-.1-.5-.3-1.1-.3-1.6-.1l-.9.4c-.1-.3-.3-.5-.5-.7-.2-.2-.4-.4-.8-.5-.6-.2-1.2-.3-1.9 0-.3.1-.5.3-.7.5-.2.2-.4.5-.5.7-.1.3-.2.6-.2.9v.1h-1.5c-.3 0-.6.1-.9.3-.3-.2-.6-.3-.9-.3h-.8c-.3 0-.7.1-.9.3-.3-.2-.6-.3-.9-.3h-1.6c-.9 0-1.6.7-1.7 1.6-.1-.9-.8-1.6-1.7-1.6h-1.9c-.2 0-.4 0-.6.1-.2-.1-.4-.1-.6-.1h-1.9c-.5 0-.9.2-1.2.5-.3-.2-.6-.4-.9-.5-.6-.2-1.3-.2-2.1-.1-.2 0-.5.1-.7.2-.2.1-.5.2-.7.3h-.1v-1.3c0-.9-.8-1.7-1.7-1.7h-1.7c-.5 0-1 .3-1.3.7-.2-.1-.3-.2-.5-.3-.4-.1-.9-.2-1.4-.2h-3c-.9 0-1.7.8-1.7 1.7v.9c0 .6.3 1.1.7 1.4v3c-.4.3-.7.8-.7 1.4v.8c0 .9.8 1.7 1.7 1.7h2.4c.9 0 1.7-.8 1.7-1.7v-.8c0-.4-.1-.7-.3-1 .3 0 .5-.1.7-.2.3-.1.5-.3.8-.5v.2c-.4.3-.7.8-.7 1.4v.8c0 .9.8 1.7 1.7 1.7h2.4c.4 0 .7-.1 1-.4.2.1.3.2.4.3.4.2.8.2 1.3.2.4 0 .8-.1 1.1-.2h2v.7c0 .9.8 1.7 1.7 1.7h2.1c.9 0 1.7-.8 1.7-1.7v-.8c0-.3-.1-.6-.2-.9l1.3-3.3c.6-.2 1-.8 1-1.4 0 .6.3 1.1.8 1.3l1.1 3.4c.2.7.9 1.2 1.6 1.2h.9c.4 0 .9-.2 1.2-.5.3.3.7.5 1.2.5h.8c.6 0 1.2-.3 1.5-.9.3.5.8.8 1.4.8h2.4c.4 0 .8-.2 1.1-.5.2.2.5.3.8.4.3.1.7.2 1.1.2.4 0 .7 0 1.1-.1.1 0 .2-.1.4-.1.2.1.4.2.7.2h2.4c.2 0 .3 0 .5-.1.2 0 .3.1.5.1h2.4c.9 0 1.7-.8 1.7-1.7v-.8c0-.6-.3-1.1-.8-1.4v-1zM187.1 88.8c-.2-.2-.5-.3-.7-.4-.8-.3-2-.4-2.9-.1-.3.1-.5.3-.8.4-.2-.2-.4-.3-.7-.4 0-.6-.3-1.1-.8-1.4-.5-.3-1.1-.3-1.6-.1l-.9.4c-.5.2-.9.7-1 1.3l-.3.3c-.2-.1-.5-.3-.7-.4-1-.4-2.3-.4-3.4 0-.5.2-1 .5-1.4 1-.4-.4-.8-.7-1.3-.9-.4-.2-.9-.3-1.4-.3v-.8c0-.9-.8-1.7-1.7-1.7h-1.7c-.9 0-1.7.8-1.7 1.7v.8c0 .1.1.2.1.4-.1-.1-.2-.1-.3-.2-1-.4-2.3-.4-3.4 0-.4.2-.7.4-1 .6 0-.4-.1-.7-.3-1-.2-.5-.5-.9-1-1.2-.4-.3-.8-.5-1.3-.7-.4-.1-.9-.2-1.4-.2h-3.1c-.9 0-1.7.8-1.7 1.7v.9c0 .6.3 1.1.7 1.4v3c-.4.3-.7.8-.7 1.4v.8c0 .9.8 1.7 1.7 1.7h2.4c.4 0 .8-.1 1-.4.3.2.7.4 1 .4h1.5c.5 0 .9-.2 1.2-.5 0 0 0-.1.1-.1.2.2.5.3.8.4.5.2 1.1.3 1.7.3.6 0 1.2-.1 1.7-.3.4-.2.8-.4 1.1-.7.3.5.8.9 1.5.9h1.2c.3.1.6.1 1 .1.6 0 1.2-.1 1.7-.3.5-.2 1-.5 1.4-1 0 0 0 .1.1.1.4.4.9.7 1.4 1 .5.2 1.1.3 1.7.3.6 0 1.2-.1 1.7-.3.5-.2 1-.6 1.4-1 0 0 0-.1.1-.1.1.1.2.3.3.4.3.4.7.6 1.2.8.3.1.7.2 1.1.2.4 0 .7 0 1.1-.1.3-.1.6-.2.8-.3l.1-.1c.1.1.2.1.3.2.5.3 1.1.4 1.7.4.5 0 .9-.1 1.3-.2s.8-.3 1.2-.6c.4-.3.7-.7.9-1.1.2-.4.3-.9.3-1.4 0-.5-.1-.9-.3-1.3.2-.3.4-.7.4-1.1v-.9c.1-.9-.6-1.6-1.4-1.7zM146.4 34.6c-1.2 0-2.2 1-2.2 2.2v39.7c0 1.2 1 2.2 2.2 2.2h6.2c1.2 0 2.2-1 2.2-2.2V36.9c0-1.2-1-2.2-2.2-2.2h-6.2zM158.5 78.8h5.6c1.2 0 2.2-1 2.2-2.2V64.4l3.4 12.7c.3 1 1.1 1.7 2.2 1.7h6.4c1.2 0 2.2-1 2.2-2.2V36.9c0-1.2-1-2.2-2.2-2.2h-5.6c-1.2 0-2.2 1-2.2 2.2V44l-2-7.6c-.3-1-1.1-1.7-2.2-1.7h-7.8c-1.2 0-2.2 1-2.2 2.2v39.7c0 1.2 1 2.2 2.2 2.2zM198.6 54.6l8.2-16.8c.3-.7.3-1.5-.1-2.1-.4-.7-1.1-1.1-1.9-1.1h-6.2c-.9 0-1.7.5-2 1.3l-3.9 8.3v-7.4c0-1.2-1-2.2-2.2-2.2h-6.2c-1.2 0-2.2 1-2.2 2.2v39.7c0 1.2 1 2.2 2.2 2.2h6.2c1.2 0 2.2-1 2.2-2.2v-8.8l3.7 9.6c.3.9 1.2 1.4 2.1 1.4h6.4c.7 0 1.4-.4 1.8-1 .4-.6.5-1.4.2-2.1l-8.3-21zM23.5 77.8c.4-.6.5-1.4.2-2.1-.5-1.1-.5-2.3-.5-3.9v-6.1c0-1.5 0-5.7-2.7-8.5 1.7-1.9 2.6-4.6 2.6-8V46c0-7.5-3.9-11.4-11.5-11.4H2.2c-1.2 0-2.2 1-2.2 2.2v39.7c0 1.2 1 2.2 2.2 2.2h6.2c1.2 0 2.2-1 2.2-2.2V62.6c1.2 0 1.8.1 1.8 2.8v6.2c0 3.4.2 4.3.7 5.6.3.9 1.2 1.5 2.1 1.5h6.3c.9.1 1.6-.3 2-.9zM12.4 46.6v3.9c0 2-.4 2-1.5 2h-.2v-7.7h.8c.6 0 .9 0 .9 1.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.4 79.2c7.3 0 11.7-4.6 11.7-12.2V46.4c0-7.6-4.4-12.2-11.7-12.2-7.3 0-11.7 4.6-11.7 12.2V67c0 7.6 4.4 12.2 11.7 12.2zm-1-11.8V46c0-1.7.4-1.7 1-1.7s1 0 1 1.7v21.4c0 1.7-.4 1.7-1 1.7s-1 0-1-1.7zM50.3 78.8h9.8c7.4 0 11.7-4.2 11.7-11.6V66l.1-.1c.2 3.1 1.2 5.7 2.9 7.6h-.2c-1.8 0-3.2 1.4-3.2 3.2 0 1.8 1.4 3.2 3.2 3.2h6.1c.9 0 1.7-.8 1.7-1.7V77c.5 0 1 .1 1.5.1.6 0 1.1-.1 1.7-.1v1.2c0 .9.8 1.7 1.7 1.7h6.1c1.8 0 3.2-1.4 3.2-3.2 0-1.8-1.4-3.2-3.2-3.2H93c1.9-2.2 3-5.2 3-9v-11h.2c.8 1.1 2.1 1.8 3.6 1.8.7 0 1.3-.2 1.9-.4v21.7c0 1.2 1 2.2 2.2 2.2h6.2c1.2 0 2.2-1 2.2-2.2V47c.1-.3.1-.6.1-1s-.1-.7-.1-1v-.2h4.3c.8 0 1.5-.5 1.9-1.1v32.9c0 1.2 1 2.2 2.2 2.2h6.2c1.2 0 2.2-1 2.2-2.2V61.8h2.6v14.8c0 1.2 1 2.2 2.2 2.2h6.3c1.2 0 2.2-1 2.2-2.2V36.9c0-1.2-1-2.2-2.2-2.2h-6.3c-1.2 0-2.2 1-2.2 2.2v14.8h-2.6V36.9c0-1.2-1-2.2-2.2-2.2h-6.2c-.9 0-1.7.6-2.1 1.4-.3-.8-1.1-1.4-2.1-1.4H97.4c-1.2 0-2.2 1-2.2 2.2v5.7c0 1.2 1 2.2 2.2 2.2h4.3v1.9c-.6-.3-1.2-.4-1.9-.4-1.2 0-2.2.5-3 1.2-.9-.1-1.7-.3-2-.4-.1 0-.2-.1-.3-.1h-.2v-3.1c0-5.6-2.7-9.3-7.3-10.4.2-.2.3-.4.3-.7.1-.5 0-1.1-.4-1.5l-.2-.2c1-.9 1.7-2.1 1.7-3.6 0-2.6-2.1-4.7-4.7-4.7S79 24.9 79 27.5c0 2 1.2 3.7 3 4.4-.5.3-.7.9-.7 1.5-4.8 1-7.7 4.8-7.7 10.5v3.3c-.7.1-1.5.2-2.4.4V46c0-7.5-3.9-11.4-11.5-11.4h-9.4c-1.2 0-2.2 1-2.2 2.2v39.7c0 1.3 1 2.3 2.2 2.3zm9.8-10.2h-1.3v-7.7h.5c1.4 0 1.8 0 1.8 2.6V67c0 1.6-.2 1.6-1 1.6zm.4-19.8c0 2-.4 2-1.5 2h-.2v-6h.8c.7 0 .9 0 .9 1.9v2.1zM71.8 61l-.3-.3c-.3-1.7-.9-3.2-1.8-4.4.6-.8 1-1.7 1-2.8v-.3c.3-.1.7-.2 1.2-.3V61zM114.2 13c3.6 0 6.5-2.9 6.5-6.5S117.8 0 114.2 0s-6.5 2.9-6.5 6.5 2.9 6.5 6.5 6.5zM129.4 14.4c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.4 5.5 5.5 5.5zM99.8 15.8c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5zM141.7 23.3c2.9 0 5.3-2.4 5.3-5.3s-2.4-5.3-5.3-5.3-5.3 2.4-5.3 5.3 2.4 5.3 5.3 5.3zM89.6 23.3c2.9 0 5.3-2.4 5.3-5.3s-2.4-5.3-5.3-5.3-5.3 2.4-5.3 5.3 2.4 5.3 5.3 5.3z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 148.8,
    cy: 29.2,
    r: 4.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.2 94.2h.7v-5.8h-.7v-.9h3.4c.3 0 .6.1.9.2.3.1.5.3.7.5.2.2.4.4.5.7.1.3.2.6.2.9 0 .3-.1.6-.3.9-.2.3-.4.5-.8.6.2.1.3.2.4.3.1.1.2.2.3.4.1.1.2.3.2.4.1.2.1.3.1.5 0 .3-.1.6-.2.9-.1.3-.3.5-.5.7-.2.2-.4.4-.7.5-.3.1-.5.2-.9.2h-3.4v-1zm1.7-5.7v2.4h1.7c.2 0 .3 0 .4-.1.1-.1.3-.1.4-.3.1-.1.2-.2.2-.4.1-.1.1-.3.1-.4 0-.2 0-.3-.1-.5s-.1-.3-.2-.4c-.1-.1-.2-.2-.4-.3-.1-.1-.3-.1-.4-.1h-1.7zm0 3.3v2.5h1.7c.2 0 .3 0 .4-.1.1-.1.3-.2.4-.3.1-.1.2-.3.2-.4.1-.2.1-.3.1-.5 0-.1 0-.3-.1-.4-.1-.1-.1-.3-.2-.4-.1-.1-.2-.2-.4-.3-.1-.1-.3-.1-.4-.1h-1.7zM30 90h1.7v4.3h.6v.8h-1.5v-.5c-.2.2-.5.3-.8.4-.3.1-.6.1-.9.1-.3 0-.5 0-.7-.1-.2-.1-.4-.2-.5-.3-.1-.2-.3-.4-.3-.6-.1-.2-.1-.5-.1-.9v-2.4h-.7V90h1.7v3.2c0 .4.1.7.3.9.2.2.4.3.8.3.2 0 .4 0 .6-.1l.6-.3v-3.1H30V90zM33.8 90h1.7v4.3h.8v.8h-2.4v-.8h.7v-3.4h-.7V90zm.6-1.8c0-.1 0-.2.1-.2 0-.1.1-.1.1-.2.1-.1.1-.1.2-.1s.2-.1.3-.1c.1 0 .2 0 .2.1.1 0 .1.1.2.1.1.1.1.1.1.2s.1.2.1.2c0 .1 0 .2-.1.3 0 .1-.1.1-.1.2-.1.1-.1.1-.2.1s-.2.1-.2.1c-.1 0-.2 0-.3-.1-.1 0-.1-.1-.2-.1-.1-.1-.1-.1-.1-.2-.1-.2-.1-.3-.1-.3zM37.3 87.4H39v6.8h.8v.8h-2.4v-.8h.6v-6h-.7v-.8zM43.9 87.4h1.6v6.8h.8v.8h-1.7v-.4c-.2.2-.4.3-.6.4-.2.1-.5.1-.7.1-.3 0-.7-.1-1-.2-.3-.1-.6-.3-.8-.5-.2-.2-.4-.5-.5-.9-.1-.3-.2-.7-.2-1.2 0-.4.1-.8.2-1.1.1-.3.3-.6.5-.8.2-.2.5-.4.8-.5.3-.1.6-.2 1-.2.2 0 .5 0 .7.1.2.1.4.1.6.3v-2h-.7v-.7zm-.5 7c.3 0 .5 0 .7-.1.2-.1.4-.2.5-.4V91l-.6-.3c-.2-.1-.4-.1-.7-.1-.2 0-.4 0-.6.1-.2.1-.4.2-.5.4-.1.2-.3.3-.3.6-.1.2-.1.5-.1.8 0 .3 0 .6.1.8l.3.6c.1.2.3.3.5.4.3.1.5.1.7.1zM47.9 93.7l1.1.4-1.3 2.7-.7-.3.9-2.8zM57.3 89.6c-.2-.4-.5-.7-.9-.9-.4-.2-.8-.3-1.2-.3-.4 0-.7.1-1 .2-.3.2-.6.4-.8.6-.2.3-.4.6-.5.9s-.2.7-.2 1.1c0 .5.1.9.2 1.2.1.4.3.7.5.9.2.2.5.4.8.6.3.2.7.2 1 .2.5 0 1-.1 1.4-.4.4-.3.7-.7 1-1.2l.9.4c-.1.4-.3.7-.6 1-.3.3-.7.6-1.1.8-.4.2-.9.3-1.5.3-.5 0-1-.1-1.4-.3-.4-.2-.8-.5-1.1-.8-.3-.4-.6-.8-.8-1.3-.2-.5-.3-1-.3-1.5s.1-1 .3-1.5c.2-.5.4-.9.7-1.2.3-.3.7-.6 1.1-.8.4-.2.9-.3 1.4-.3.5 0 .9.1 1.2.2.3.1.6.3.8.5l.6.6h.5v.9h-1zM59.4 92.5c0-.4.1-.8.2-1.1.1-.3.3-.6.5-.9.2-.2.5-.4.8-.6.3-.1.7-.2 1-.2.4 0 .7.1 1 .2.3.1.6.3.8.5.2.2.4.5.5.9.1.3.2.7.2 1.1 0 .4-.1.8-.2 1.1-.1.3-.3.6-.5.9-.2.2-.5.4-.8.6-.3.1-.7.2-1 .2-.4 0-.7-.1-1-.2-.3-.1-.6-.3-.8-.6-.2-.2-.4-.5-.5-.9-.1-.2-.2-.6-.2-1zm1 0c0 .3 0 .6.1.8l.3.6c.1.2.3.3.5.4.2.1.4.1.6.1.2 0 .4 0 .6-.1.2-.1.4-.2.5-.4.1-.2.3-.4.3-.6.1-.2.1-.5.1-.8 0-.3 0-.6-.1-.8l-.3-.6c-.1-.2-.3-.3-.5-.4-.2-.1-.4-.1-.6-.1-.2 0-.4 0-.6.1-.2.1-.4.2-.5.4-.1.2-.3.4-.3.6-.1.2-.1.5-.1.8zM68.8 87.4h1.6v6.8h.8v.8h-1.7v-.4c-.2.2-.4.3-.6.4-.2.1-.5.1-.7.1-.3 0-.7-.1-1-.2-.3-.1-.6-.3-.8-.5-.2-.2-.4-.5-.5-.9-.1-.3-.2-.7-.2-1.2 0-.4.1-.8.2-1.1.1-.3.3-.6.5-.8.2-.2.5-.4.8-.5.3-.1.6-.2 1-.2.2 0 .5 0 .7.1.2.1.4.1.6.3v-2h-.7v-.7zm-.5 7c.3 0 .5 0 .7-.1.2-.1.4-.2.5-.4V91l-.6-.3c-.2-.1-.4-.1-.7-.1-.2 0-.4 0-.6.1-.2.1-.4.2-.5.4-.1.2-.3.3-.3.6-.1.2-.1.5-.1.8 0 .3 0 .6.1.8l.3.6c.1.2.3.3.5.4.3.1.5.1.7.1zM73.2 92.6v.4c0 .1.1.2.1.3.1.3.3.6.6.7.3.2.6.2.9.2.3 0 .5 0 .8-.1.3-.1.5-.2.8-.3l.4.6c-.3.2-.7.4-1 .5-.3.1-.7.2-1.1.2-.3 0-.7-.1-1-.2-.3-.1-.5-.3-.8-.5-.2-.2-.4-.5-.5-.9-.1-.3-.2-.7-.2-1.2 0-.4.1-.7.2-1 .1-.3.3-.6.5-.8.2-.2.5-.4.8-.6.3-.1.6-.2 1-.2s.7.1 1 .2c.3.1.5.3.6.5.2.2.3.4.4.7.1.2.1.5.2.8v.8h-3.7zm1.4-2c-.2 0-.4 0-.6.1-.2.1-.3.1-.4.3-.1.1-.2.3-.3.4-.1.2-.1.3-.2.6h2.7c0-.2 0-.4-.1-.5 0-.2-.1-.3-.2-.4-.1-.1-.2-.2-.4-.3-.1-.2-.2-.2-.5-.2zM83.9 94.6c-.2.2-.4.3-.6.4-.2.1-.5.2-.8.2-.2 0-.5 0-.7-.1-.2-.1-.4-.2-.5-.3-.2-.1-.3-.3-.4-.5-.1-.2-.1-.4-.1-.6 0-.2 0-.4.1-.6.1-.2.1-.3.3-.4.1-.1.2-.2.4-.3.1-.1.3-.2.5-.2.2-.1.3-.1.5-.1h1.1c.2 0 .3 0 .4.1v-.4c0-.2 0-.3-.1-.5-.1-.1-.1-.2-.2-.3-.1-.1-.2-.2-.3-.2-.1 0-.3-.1-.4-.1h-.4c-.1 0-.3 0-.4.1-.1 0-.2.1-.3.1-.1 0-.2.1-.3.1l-.7-.6c.1-.1.3-.2.4-.2.1-.1.3-.1.5-.2.2 0 .3-.1.5-.1h.5c.3 0 .6 0 .8.1l.6.3c.2.1.3.3.4.6.1.2.1.5.1.8v2.6h.6v.8h-1.5v-.5zm-1.3-.1h.4c.1 0 .2-.1.3-.1.1-.1.2-.1.3-.2.1-.1.2-.1.2-.2v-1.2h-1.1c-.2 0-.3 0-.5.1-.1 0-.3.1-.4.2-.1.1-.2.2-.2.3-.1.1-.1.2-.1.4 0 .1 0 .3.1.4 0 .1.1.2.2.3.1.1.2.1.3.2.2-.3.4-.2.5-.2zM90 94.2h.7v-2.3c0-.4-.1-.7-.3-.9-.2-.2-.5-.3-.9-.3-.2 0-.4.1-.6.2-.2.1-.4.2-.6.4v3h.7v.8h-2.4v-.8h.7v-3.4h-.7V90h1.6v.6l.3-.3c.1-.1.3-.2.4-.2.1-.1.3-.1.4-.1.1 0 .3-.1.5-.1.3 0 .5 0 .7.1l.6.3c.2.2.3.4.4.6.1.2.1.5.1.9v2.5h.7v.8H90v-.9zM96.7 87.4h1.6v6.8h.7v.8h-1.7v-.4c-.2.2-.4.3-.6.4-.2.1-.5.1-.7.1-.3 0-.7-.1-1-.2-.3-.1-.6-.3-.8-.5-.2-.2-.4-.5-.5-.9-.1-.3-.2-.7-.2-1.2 0-.4.1-.8.2-1.1.1-.3.3-.6.5-.8.2-.2.5-.4.8-.5.3-.1.6-.2 1-.2.2 0 .5 0 .7.1.2.1.4.1.6.3v-2h-.7v-.7zm-.5 7c.3 0 .5 0 .7-.1.2-.1.4-.2.5-.4V91l-.6-.3c-.2-.1-.4-.1-.7-.1-.2 0-.4 0-.6.1-.2.1-.4.2-.5.4-.1.2-.3.3-.3.6-.1.2-.1.5-.1.8 0 .3 0 .6.1.8l.3.6c.1.2.3.3.5.4.2.1.4.1.7.1zM102.8 87.6h3c.3 0 .6 0 .9.1.3.1.5.2.7.4.2.2.4.4.5.6.1.3.2.5.2.9 0 .3-.1.5-.2.8-.1.2-.3.5-.5.6-.2.2-.4.3-.7.4-.3.1-.6.2-1 .2h-1.3v2.6h.8v.8h-2.4v-.8h.7v-5.8h-.7v-.8zm1.7.9v2.4h1.3c.2 0 .4 0 .5-.1.2-.1.3-.1.4-.2.1-.1.2-.2.3-.4.1-.1.1-.3.1-.5 0-.4-.1-.7-.3-.9-.2-.2-.6-.3-1.1-.3h-1.2zM109.1 87.4h1.7v6.8h.8v.8h-2.4v-.8h.7v-6h-.7v-.8zM115.7 94.6c-.2.2-.4.3-.6.4-.2.1-.5.2-.8.2-.2 0-.5 0-.7-.1-.2-.1-.4-.2-.5-.3-.2-.1-.3-.3-.4-.5-.1-.2-.1-.4-.1-.6 0-.2 0-.4.1-.6.1-.2.1-.3.3-.4.1-.1.2-.2.4-.3.1-.1.3-.2.5-.2.2-.1.3-.1.5-.1h1.1c.2 0 .3 0 .4.1v-.4c0-.2 0-.3-.1-.5-.1-.1-.1-.2-.2-.3-.1-.1-.2-.2-.3-.2-.1 0-.3-.1-.4-.1h-.4c-.1 0-.3 0-.4.1-.1 0-.2.1-.3.1-.1 0-.2.1-.3.1l-.3-.6c.1-.1.3-.2.4-.2.1-.1.3-.1.5-.2.2 0 .3-.1.5-.1h.5c.3 0 .6 0 .8.1l.6.3c.2.1.3.3.4.6.1.2.1.5.1.8v2.6h.6v.8h-1.5v-.5zm-1.2-.1h.4c.1 0 .2-.1.3-.1.1-.1.2-.1.3-.2.1-.1.2-.1.2-.2v-1.2h-1.1c-.2 0-.3 0-.5.1-.1 0-.3.1-.4.2-.1.1-.2.2-.2.3-.1.1-.1.2-.1.4 0 .1 0 .3.1.4 0 .1.1.2.2.3.1.1.2.1.3.2.2-.3.3-.2.5-.2zM118.2 90h1.9v.8h-.6l1.2 3.3 1.3-3.3h-.6V90h1.9v.8h-.5l-2.3 5.8h.7v.8h-2.1v-.8h.6l.5-1.4-1.7-4.3h-.4V90zM126.7 90h1.6v.8h-.3l.9 3.3 1.2-4.1h.8l1.2 4.1.9-3.3h-.3V90h1.6v.8h-.4l-1.4 4.4h-.8l-1.2-4.1-1.2 4.1h-.9l-1.4-4.4h-.4V90zM135.4 90h1.7v4.3h.8v.8h-2.4v-.8h.7v-3.4h-.7V90zm.5-1.8c0-.1 0-.2.1-.2 0-.1.1-.1.1-.2.1-.1.1-.1.2-.1s.2-.1.3-.1c.1 0 .2 0 .2.1.1 0 .1.1.2.1.1.1.1.1.1.2s.1.2.1.2c0 .1 0 .2-.1.3 0 .1-.1.1-.1.2-.1.1-.1.1-.2.1s-.2.1-.2.1c-.1 0-.2 0-.3-.1-.1 0-.1-.1-.2-.1-.1-.1-.1-.1-.1-.2 0-.2-.1-.3-.1-.3zM140.4 90h1.2v.7h-1.2v3c0 .2 0 .4.1.5 0 .1.1.2.2.3.1 0 .2.1.3.1h.4c.1 0 .2-.1.3-.1l.2.6c-.2.1-.3.1-.5.2-.2 0-.4.1-.6.1-.2 0-.4 0-.6-.1-.2-.1-.3-.1-.4-.3-.1-.1-.2-.3-.3-.5-.1-.2-.1-.5-.1-.8v-2.8h-.8V90h.8v-1.2l.9-.4V90zM143 87.4h1.6v3.1l.3-.3c.1-.1.2-.2.4-.2.1-.1.3-.1.4-.1h.4c.3 0 .5 0 .7.1l.6.3c.2.2.3.4.4.6.1.2.1.5.1.9v2.5h.8v.8h-2.4v-.8h.7V92c0-.4-.1-.7-.3-.9-.2-.2-.5-.3-.9-.3-.2 0-.4.1-.6.2-.2.1-.4.2-.6.4v3h.7v.8h-2.4v-.8h.8v-6h-.7v-1zM152.6 87.6h3.1c.3 0 .6 0 .9.1.3.1.5.2.7.4.2.2.4.4.5.6.1.3.2.5.2.9 0 .2 0 .4-.1.6-.1.2-.2.4-.3.5-.1.2-.3.3-.4.4-.2.1-.3.2-.5.3.1 0 .2.1.2.2l.2.2c.1.1.1.2.2.3.1.1.1.3.1.4l.4 1.6h.6v.9h-1.5l-.6-2.3c-.1-.4-.3-.7-.5-.9-.2-.2-.5-.3-.9-.3h-1v2.6h.8v.8h-2.4v-.8h.7v-5.8h-.7v-.7zm1.6.9v2.4h1.4c.2 0 .4 0 .5-.1.2 0 .3-.1.4-.2.1-.1.2-.2.3-.4.1-.1.1-.3.1-.5 0-.4-.1-.7-.3-.9-.2-.2-.6-.3-1.1-.3h-1.3zM159.7 92.5c0-.4.1-.8.2-1.1.1-.3.3-.6.5-.9.2-.2.5-.4.8-.6.3-.1.7-.2 1-.2.4 0 .7.1 1 .2.3.1.6.3.8.5.2.2.4.5.5.9.1.3.2.7.2 1.1 0 .4-.1.8-.2 1.1-.1.3-.3.6-.5.9-.2.2-.5.4-.8.6-.3.1-.7.2-1 .2-.4 0-.7-.1-1-.2-.3-.1-.6-.3-.8-.6-.2-.2-.4-.5-.5-.9-.1-.2-.2-.6-.2-1zm1 0c0 .3 0 .6.1.8l.3.6c.1.2.3.3.5.4.2.1.4.1.6.1.2 0 .4 0 .6-.1.2-.1.4-.2.5-.4.1-.2.3-.4.3-.6.1-.2.1-.5.1-.8 0-.3 0-.6-.1-.8l-.3-.6c-.1-.2-.3-.3-.5-.4-.2-.1-.4-.1-.6-.1-.2 0-.4 0-.6.1-.2.1-.4.2-.5.4-.1.2-.3.4-.3.6 0 .2-.1.5-.1.8zM165.9 87.4h1.7v3c.2-.2.5-.3.7-.4.3-.1.5-.1.8-.1.3 0 .6.1.9.2.3.1.5.3.7.5.2.2.4.5.5.8.1.3.2.7.2 1.1 0 .4-.1.8-.2 1.1-.1.3-.3.6-.5.9-.2.2-.5.4-.8.6-.3.1-.6.2-1 .2-.3 0-.5 0-.7-.1l-.6-.3v.3h-.9v-6.8h-.7v-1zm2.9 3.3c-.2 0-.5 0-.7.1-.2.1-.4.2-.6.4V94c.1.1.3.2.5.3.2.1.5.1.8.1.2 0 .4 0 .6-.1.2-.1.4-.2.5-.4.1-.2.3-.4.4-.6.1-.2.1-.5.1-.8 0-.3 0-.5-.1-.8l-.3-.6c-.1-.2-.3-.3-.5-.4h-.7zM172.5 92.5c0-.4.1-.8.2-1.1.1-.3.3-.6.5-.9.2-.2.5-.4.8-.6.3-.1.7-.2 1-.2.4 0 .7.1 1 .2.3.1.6.3.8.5.2.2.4.5.5.9.1.3.2.7.2 1.1 0 .4-.1.8-.2 1.1-.1.3-.3.6-.5.9-.2.2-.5.4-.8.6-.3.1-.7.2-1 .2-.4 0-.7-.1-1-.2-.3-.1-.6-.3-.8-.6-.2-.2-.4-.5-.5-.9-.1-.2-.2-.6-.2-1zm1 0c0 .3 0 .6.1.8l.3.6c.1.2.3.3.5.4.2.1.4.1.6.1.2 0 .4 0 .6-.1.2-.1.4-.2.5-.4.1-.2.3-.4.3-.6.1-.2.1-.5.1-.8 0-.3 0-.6-.1-.8l-.3-.6c-.1-.2-.3-.3-.5-.4-.2-.1-.4-.1-.6-.1-.2 0-.4 0-.6.1-.2.1-.4.2-.5.4-.1.2-.3.4-.3.6-.1.2-.1.5-.1.8zM180.4 90h1.2v.7h-1.2v3c0 .2 0 .4.1.5 0 .1.1.2.2.3.1 0 .2.1.3.1h.4c.1 0 .2-.1.3-.1l.2.6c-.2.1-.3.1-.5.2-.2 0-.4.1-.6.1-.2 0-.4 0-.6-.1-.2-.1-.3-.1-.4-.3-.1-.1-.2-.3-.3-.5-.1-.2-.1-.5-.1-.8v-2.8h-.8V90h.8v-1.2l.9-.4V90zM185.8 91c-.1-.1-.1-.2-.3-.2-.1-.1-.2-.1-.3-.1h-.8c-.1 0-.2.1-.3.1l-.2.2c0 .1-.1.2-.1.3 0 .2.1.3.2.4.1.1.3.2.5.3l1 .3c.4.1.7.3.9.6.2.2.3.5.3.9 0 .2 0 .4-.1.6-.1.2-.2.4-.4.5l-.6.3c-.2.1-.5.1-.8.1-.4 0-.7-.1-1-.2-.2-.1-.4-.3-.6-.5h-.5v-.9h1c0 .1 0 .3.1.4.1.1.1.2.2.2.1.1.2.1.3.1h.8c.1 0 .2-.1.3-.1.1-.1.2-.1.2-.2.1-.1.1-.2.1-.3 0-.2-.1-.3-.2-.4-.1-.1-.3-.2-.5-.3l-1-.4c-.4-.1-.7-.3-.9-.5-.2-.2-.3-.5-.3-.8 0-.2 0-.4.1-.6.1-.2.2-.3.4-.5.2-.1.3-.2.6-.3.2-.1.5-.1.8-.1.4 0 .7.1.9.2.2.1.5.3.7.5h.5v.9h-1c.1-.3 0-.4 0-.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 130.6103,
    y1: 19.1748,
    x2: 130.6103,
    y2: 62.7359
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f79554"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f27623"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4632a"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M134.1 77.1c-.3 0-.5-.2-.5-.5V60.1h-6v16.5c0 .3-.2.5-.5.5h-6.2c-.3 0-.5-.2-.5-.5V36.9c0-.3.2-.5.5-.5h6.2c.3 0 .5.2.5.5v16.5h6V36.9c0-.3.2-.5.5-.5h6.3c.3 0 .5.2.5.5v39.7c0 .3-.2.5-.5.5h-6.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 130.6103,
    y1: 29.787,
    x2: 130.6103,
    y2: 70.5649
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f79554"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f27623"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4632a"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M127 76.5h-6.2V36.9h6.2v17h7.1v-17h6.3v39.7h-6.3v-17H127v16.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 149.5107,
    y1: 19.1748,
    x2: 149.5107,
    y2: 62.7359
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fee7a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ffcb09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8ac1c"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M146.4 77.1c-.3 0-.5-.2-.5-.5V36.9c0-.3.2-.5.5-.5h6.2c.3 0 .5.2.5.5v39.7c0 .3-.2.5-.5.5h-6.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 149.5107,
    y1: 29.787,
    x2: 149.5107,
    y2: 70.5649
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fee7a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ffcb09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8ac1c"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M146.4 36.9h6.2v39.7h-6.2V36.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 168.4102,
    y1: 19.1748,
    x2: 168.4102,
    y2: 62.7359
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d2e5a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#acd479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#77b843"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M171.9 77.1c-.2 0-.5-.2-.5-.4l-6.7-25.2v25.1c0 .3-.2.5-.5.5h-5.6c-.3 0-.5-.2-.5-.5V36.9c0-.3.2-.5.5-.5h7.8c.2 0 .5.2.5.4l5.4 20.2V36.9c0-.3.2-.5.5-.5h5.6c.3 0 .5.2.5.5v39.7c0 .3-.2.5-.5.5h-6.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 168.4105,
    y1: 29.787,
    x2: 168.4105,
    y2: 70.5649
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d2e5a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#acd479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#77b843"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M164.2 47.8h-.1v28.7h-5.6V36.9h7.8l6.3 23.7h.1V36.9h5.6v39.7h-6.4l-7.7-28.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 194.5083,
    y1: 19.1748,
    x2: 194.5083,
    y2: 62.7359
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f37f5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#eb2227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cf232b"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M198.4 77.1c-.2 0-.4-.1-.5-.3L192.3 62l-1.3 2.5v12.1c0 .3-.2.5-.5.5h-6.2c-.3 0-.5-.2-.5-.5V36.9c0-.3.2-.5.5-.5h6.2c.3 0 .5.2.5.5v15l7.1-15.3c.1-.2.3-.3.5-.3h6.2c.2 0 .4.1.4.2.1.2.1.4 0 .5l-8.6 17.5 8.6 21.8c.1.2 0 .3-.1.5-.1.1-.3.2-.4.2h-6.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 194.5089,
    y1: 29.787,
    x2: 194.5089,
    y2: 70.5649
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f37f5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#eb2227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cf232b"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M192.4 60.7l-1.9 3.6v12.2h-6.2V36.9h6.2V54h.1l8-17.2h6.2l-8.7 17.7 8.7 22h-6.4l-6-15.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 107.0058,
    y1: 19.1748,
    x2: 107.0058,
    y2: 62.7359
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#33c4f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2aace3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e94d2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M103.9 77.1c-.3 0-.5-.2-.5-.5V43.1h-6c-.3 0-.5-.2-.5-.5v-5.7c0-.3.2-.5.5-.5h19.3c.3 0 .5.2.5.5v5.7c0 .3-.2.5-.5.5h-6v33.5c0 .3-.2.5-.5.5h-6.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 107.0058,
    y1: 29.787,
    x2: 107.0058,
    y2: 70.5649
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#33c4f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2aace3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e94d2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M97.4 36.9h19.3v5.7h-6.5v34H104v-34h-6.5v-5.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.9199,
    y1: 19.1748,
    x2: 11.9199,
    y2: 62.7359
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f37f5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#eb2227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cf232b"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M15.3 77.1c-.2 0-.4-.1-.5-.4v-.1c-.3-1-.6-1.7-.6-5v-6.2c0-3.8-1.4-4.5-3.5-4.5H9v15.6c0 .3-.2.5-.5.5H2.2c-.3 0-.5-.2-.5-.5V36.9c0-.3.2-.5.5-.5h9.4c6.7 0 9.8 3.1 9.8 9.7v3.1c0 3.9-1.2 6.5-3.6 8 3.2 1.9 3.6 5.7 3.6 8.5v6.1c0 1.8 0 3.2.6 4.6.1.2.1.4 0 .5-.1.1-.3.2-.4.2h-6.3zm-4.4-22.9c2.3 0 3.2-1.1 3.2-3.7v-3.9c0-2.9-1.1-3.6-2.6-3.6H9v11.1h1.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.9194,
    y1: 29.787,
    x2: 11.9194,
    y2: 70.5649
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f37f5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#eb2227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cf232b"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M15.3 76.5c-.3-1-.6-1.6-.6-4.9v-6.2c0-3.7-1.2-5-4.1-5H8.5v16.2H2.2V36.9h9.4c6.5 0 9.2 3 9.2 9.1v3.1c0 4.1-1.3 6.7-4.1 8v.1c3.1 1.3 4.1 4.3 4.1 8.4v6.1c0 1.9.1 3.3.7 4.8h-6.2zm-6.8-34v12.2h2.4c2.3 0 3.7-1 3.7-4.2v-3.9c0-2.8-1-4.1-3.2-4.1H8.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 35.3829,
    y1: 19.1754,
    x2: 35.3829,
    y2: 62.7358
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fee7a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ffcb09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8ac1c"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M35.4 77.5c-6.4 0-10-3.8-10-10.5V46.4c0-6.7 3.6-10.5 10-10.5s10 3.8 10 10.5V67c0 6.7-3.7 10.5-10 10.5zm0-34.9c-1.3 0-2.7.4-2.7 3.4v21.4c0 3 1.4 3.4 2.7 3.4 1.3 0 2.7-.4 2.7-3.4V46c0-3-1.5-3.4-2.7-3.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 35.3829,
    y1: 29.7871,
    x2: 35.3829,
    y2: 70.564
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fee7a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ffcb09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8ac1c"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M25.9 46.4c0-6.3 3.3-10 9.5-10 6.1 0 9.5 3.6 9.5 10V67c0 6.3-3.3 10-9.5 10-6.1 0-9.5-3.6-9.5-10V46.4zm6.3 21c0 2.8 1.2 3.9 3.2 3.9s3.2-1.1 3.2-3.9V46c0-2.8-1.2-3.9-3.2-3.9s-3.2 1.1-3.2 3.9v21.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 59.9225,
    y1: 19.1748,
    x2: 59.9225,
    y2: 62.7359
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005618,
    stopColor: "#8ad0c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#04b5a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02a185"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M50.3 77.1c-.3 0-.5-.2-.5-.5V36.9c0-.3.2-.5.5-.5h9.4c6.7 0 9.8 3.1 9.8 9.7v1.4c0 3.9-1.1 6.5-3.5 8 2.8 1.5 4.1 4.3 4.1 8.5v3.2c0 6.4-3.5 9.9-10 9.9h-9.8zm9.8-6.8c1.7 0 2.7-.6 2.7-3.4v-3.5c0-3.6-1.2-4.3-3.5-4.3h-2.2v11.1h3zM59 52.5c2.3 0 3.2-1.1 3.2-3.7v-2.2c0-2.9-1.1-3.6-2.6-3.6h-2.5v9.4H59z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 59.9222,
    y1: 29.787,
    x2: 59.9222,
    y2: 70.5649
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005618,
    stopColor: "#8ad0c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#04b5a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02a185"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M68.9 46v1.4c0 4.1-1.2 6.6-4 7.9v.1c3.3 1.3 4.6 4.3 4.6 8.4V67c0 6.1-3.2 9.4-9.5 9.4h-9.8V36.9h9.4c6.6 0 9.3 3 9.3 9.1zm-12.4-3.5V53H59c2.3 0 3.7-1 3.7-4.2v-2.2c0-2.8-1-4.1-3.2-4.1h-3zm0 16.2v12.2h3.6c2.1 0 3.2-1 3.2-3.9v-3.5c0-3.7-1.2-4.8-4-4.8h-2.8z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_17_",
    cx: 81.8632,
    cy: 25.6042,
    r: 43.5282,
    gradientTransform: "translate(0 .0056234)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5e2df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4f2f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1226,
    stopColor: "#edecec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3567,
    stopColor: "#c9c8c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5225,
    stopColor: "#aeafb1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6075,
    stopColor: "#a0a1a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7506,
    stopColor: "#818587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9331,
    stopColor: "#575e61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#475154"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M93.3 75.1h-2.2v-7H76.7v7h-2.2c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5H80.6V71H87.2v7.1h6.2c.8 0 1.5-.7 1.5-1.5s-.7-1.5-1.6-1.5z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_18_",
    cx: 79.802,
    cy: 19.7054,
    r: 5.4439,
    gradientTransform: "translate(0 .0056234)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5e2df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4f2f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1226,
    stopColor: "#edecec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3567,
    stopColor: "#c9c8c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5225,
    stopColor: "#aeafb1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6075,
    stopColor: "#a0a1a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7506,
    stopColor: "#818587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9331,
    stopColor: "#575e61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#475154"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M84 36.5l-1.1-3.2 2-1-2.6-2.9 1.5-1.9.3.3-1.3 1.6 2.8 3-2.2 1.1 1 2.8z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_19_",
    cx: 87.8668,
    cy: 24.5615,
    r: 24.4079,
    gradientTransform: "translate(0 .0056234)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5e2df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4f2f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1226,
    stopColor: "#edecec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3567,
    stopColor: "#c9c8c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5225,
    stopColor: "#aeafb1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6075,
    stopColor: "#a0a1a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7506,
    stopColor: "#818587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9331,
    stopColor: "#575e61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#475154"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M83.9 34.8c-5.6 0-8.6 3.3-8.6 9.1v3.6h17.3v-3.6c-.1-5.8-3.1-9.1-8.7-9.1zm-3.4 9.5c-.9 0-1.7-.8-1.7-1.7 0-.9.8-1.7 1.7-1.7.9 0 1.7.8 1.7 1.7 0 1-.8 1.7-1.7 1.7zm6.7 0c-.9 0-1.7-.8-1.7-1.7 0-.9.8-1.7 1.7-1.7.9 0 1.7.8 1.7 1.7 0 1-.7 1.7-1.7 1.7z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_20_",
    cx: 88.2198,
    cy: 23.9447,
    r: 39.9832,
    gradientTransform: "translate(0 .0056234)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5e2df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4f2f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1226,
    stopColor: "#edecec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3567,
    stopColor: "#c9c8c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5225,
    stopColor: "#aeafb1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6075,
    stopColor: "#a0a1a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7506,
    stopColor: "#818587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9331,
    stopColor: "#575e61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#475154"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M71 63.5c0 1.1-.9 2.1-2.1 2.1-1.1 0-2.1-.9-2.1-2.1 0-1.1.9-2.1 2.1-2.1 1.2 0 2.1.9 2.1 2.1z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_21_",
    cx: 88.2214,
    cy: 23.9439,
    r: 39.9839,
    gradientTransform: "translate(0 .0056234)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5e2df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4f2f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1226,
    stopColor: "#edecec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3567,
    stopColor: "#c9c8c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5225,
    stopColor: "#aeafb1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6075,
    stopColor: "#a0a1a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7506,
    stopColor: "#818587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9331,
    stopColor: "#575e61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#475154"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M107.5 45c-3.3 6.4-13.1 3.7-13.2 3.7-4.1-.4-18-.1-19 0-2.2.2-6.8 1-8.5 2.3-1 .8-1.5 2-1.5 3.2 0 5.9 2.8 9.7 2.9 9.8l1.7-1.3s-2.5-3.5-2.5-8.6c0-.7.2-1.2.8-1.6 1.1-1 3.1-1.4 5.3-1.6v13.4c0 7 3.7 11 10.4 11s10.4-4 10.4-11v-13c.7.2 1.6.4 2.5.4 4.1 0 10-.9 12.6-5.8l-1.9-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.6 59.8c0 3-2.4 5.4-5.4 5.4-3 0-5.4-2.4-5.4-5.4 0-3 2.4-5.4 5.4-5.4 3 0 5.4 2.4 5.4 5.4z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_22_",
    cx: 85.3908,
    cy: 55.2291,
    r: 8.2296,
    gradientTransform: "translate(0 .0056234)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d2e5a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#acd479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#77b843"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M88.4 59.8c0 2.3-1.9 4.2-4.2 4.2S80 62.1 80 59.8c0-2.3 1.9-4.2 4.2-4.2s4.2 1.9 4.2 4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M85.6 57.1c0 .5-.6.9-1.4.9-.8 0-1.4-.4-1.4-.9s.6-.9 1.4-.9c.7-.1 1.4.4 1.4.9z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_23_",
    cx: 88.2252,
    cy: 23.942,
    r: 39.9883,
    gradientTransform: "translate(0 .0056234)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5e2df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4f2f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1226,
    stopColor: "#edecec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3567,
    stopColor: "#c9c8c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5225,
    stopColor: "#aeafb1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6075,
    stopColor: "#a0a1a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7506,
    stopColor: "#818587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9331,
    stopColor: "#575e61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#475154"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M68.9 53.6c0 1.6-1.3 2.8-2.8 2.8-1.6 0-2.8-1.3-2.8-2.8 0-1.6 1.3-2.8 2.8-2.8 1.6 0 2.8 1.2 2.8 2.8z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_24_",
    cx: 88.2203,
    cy: 23.9447,
    r: 39.9838,
    gradientTransform: "translate(0 .0056234)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5e2df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4f2f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1226,
    stopColor: "#edecec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3567,
    stopColor: "#c9c8c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5225,
    stopColor: "#aeafb1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6075,
    stopColor: "#a0a1a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7506,
    stopColor: "#818587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9331,
    stopColor: "#575e61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#475154"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M102.6 50.8c0 1.6-1.3 2.8-2.8 2.8-1.6 0-2.8-1.3-2.8-2.8 0-1.6 1.3-2.8 2.8-2.8 1.5-.1 2.8 1.2 2.8 2.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 109.3689,
    y1: 6.4963,
    x2: 118.9647,
    y2: 6.4963
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d2e5a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#acd479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#77b843"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M119 6.5c0 2.6-2.1 4.8-4.8 4.8-2.6 0-4.8-2.1-4.8-4.8 0-2.7 2.1-4.8 4.8-4.8 2.6 0 4.8 2.1 4.8 4.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 125.5887,
    y1: 8.9074,
    x2: 133.151,
    y2: 8.9074
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f37f5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#eb2227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cf232b"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M133.2 8.9c0 2.1-1.7 3.8-3.8 3.8-2.1 0-3.8-1.7-3.8-3.8s1.7-3.8 3.8-3.8c2.1 0 3.8 1.7 3.8 3.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 95.9914,
    y1: 10.2785,
    x2: 103.5543,
    y2: 10.2785
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f79554"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f27623"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4632a"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M103.6 10.3c0 2.1-1.7 3.8-3.8 3.8-2.1 0-3.8-1.7-3.8-3.8 0-2.1 1.7-3.8 3.8-3.8 2.1 0 3.8 1.7 3.8 3.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 138.1107,
    y1: 17.9792,
    x2: 145.2926,
    y2: 17.9792
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005618,
    stopColor: "#8ad0c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#04b5a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02a185"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st30",
    cx: 141.7,
    cy: 18,
    r: 3.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 86.0453,
    y1: 17.9792,
    x2: 93.2267,
    y2: 17.9792
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#33c4f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2aace3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e94d2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M93.2 18c0 2-1.6 3.6-3.6 3.6S86 20 86 18s1.6-3.6 3.6-3.6 3.6 1.6 3.6 3.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 145.8231,
    y1: 29.2175,
    x2: 151.7209,
    y2: 29.2175
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fee7a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ffcb09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8ac1c"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M151.7 29.2c0 1.6-1.3 2.9-2.9 2.9-1.6 0-2.9-1.3-2.9-2.9 0-1.6 1.3-2.9 2.9-2.9 1.6 0 2.9 1.3 2.9 2.9z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_31_",
    cx: 106.0045,
    cy: 24.0125,
    r: 29.49,
    gradientTransform: "translate(0 .0056234)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5e2df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4f2f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1226,
    stopColor: "#edecec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3567,
    stopColor: "#c9c8c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5225,
    stopColor: "#aeafb1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6075,
    stopColor: "#a0a1a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7506,
    stopColor: "#818587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9331,
    stopColor: "#575e61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#475154"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M110.8 46c0 1.1-.9 2.1-2.1 2.1-1.1 0-2.1-.9-2.1-2.1 0-1.1.9-2.1 2.1-2.1 1.2 0 2.1.9 2.1 2.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_32_",
    cx: 83.6337,
    cy: 27.5182,
    r: 3.032,
    gradientTransform: "translate(0 .0056234)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5e2df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4f2f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1226,
    stopColor: "#edecec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3567,
    stopColor: "#c9c8c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5225,
    stopColor: "#aeafb1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6075,
    stopColor: "#a0a1a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7506,
    stopColor: "#818587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9331,
    stopColor: "#575e61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#475154"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M83.6 30.6c-1.7 0-3-1.4-3-3 0-1.7 1.4-3 3-3 1.7 0 3 1.4 3 3 .1 1.6-1.3 3-3 3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.1 27.5c0 1.4-1.1 2.5-2.5 2.5s-2.5-1.1-2.5-2.5 1.1-2.5 2.5-2.5c1.4.1 2.5 1.2 2.5 2.5z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_33_",
    cx: 84.1713,
    cy: 25.441,
    r: 3.7302,
    gradientTransform: "translate(0 .0056234)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d2e5a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#acd479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#77b843"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M85.5 27.5c0 1.1-.9 1.9-1.9 1.9-1.1 0-1.9-.9-1.9-1.9 0-1.1.9-1.9 1.9-1.9 1.1 0 1.9.9 1.9 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M84.3 26.3c0 .2-.3.4-.6.4-.4 0-.6-.2-.6-.4s.3-.4.6-.4.6.1.6.4z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobothink);
export default __webpack_public_path__ + "static/media/robothink.3e7434a205d27d28223120c5a1b96987.svg";
export { ForwardRef as ReactComponent };